<div class="w-60 rounded border shadow-sm bg-card mt-1.5">
  <!-- HEADER -->
  <div class="flex items-center m-2 mr-2">
    <div class="flex items-center">
      <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_solid:search'"
      ></mat-icon>

      <!-- Search input -->
      <div class="ml-2">
        <input
          class="w-full min-w-0 py-1 border-0"
          type="text"
          [placeholder]="searchInputPlaceholder"
          [formControl]="searchControl"
          [value]="itemsSelector.search.value"
          [maxLength]="30"
          #newTagInput
        />
      </div>
    </div>
    <!-- Add new item button -->
    <button
      *ngIf="itemsSelector.showAddNewButton"
      (click)="addNew()"
      class="ml-1 w-8 h-8 min-h-8"
      mat-icon-button
    >
      <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_solid:plus'"
      ></mat-icon>
    </button>
  </div>

  <!-- BODY -->
  <div class="flex flex-col max-h-64 py-2 border-t overflow-y-overlay">
    <!-- Tags -->
    <ng-container *ngIf="itemsSelector.items | async as items">
      <ng-container *ngIf="!(itemsSelector.loading | async); else loading">
        <ng-container *ngFor="let item of items; trackBy: trackByFn">
          <div
            (click)="toggleSelection(item)"
            (mousedown)="$event.stopPropagation(); $event.preventDefault()"
            class="flex items-center h-10 min-h-10 px-4 cursor-pointer hover:bg-hover"
          >
            <mat-checkbox
              *ngIf="itemsSelector.multipleSelection; else radio"
              class="flex items-center h-10 min-h-10 pointer-events-none"
              [checked]="this.itemsSelector.selectedItemsMap.has(item.id)"
              [color]="'primary'"
              [disableRipple]="true"
            >
            </mat-checkbox>
            <ng-template #radio>
              <mat-radio-button
                class="flex items-center h-10 min-h-10 pointer-events-none"
                [checked]="this.itemsSelector.selectedItemsMap.has(item.id)"
                [color]="'primary'"
                [name]="item.id"
                [disableRipple]="true"
              >
              </mat-radio-button>
            </ng-template>

            <div class="ml-1">{{ item.title }}</div>
          </div>
        </ng-container>

        <div
          *ngIf="!items.length"
          class="flex py-4 items-center justify-center"
        >
          <mat-icon class="mr-3" [svgIcon]="'feather:info'"></mat-icon>
          <span>{{ noItemFoundText }}</span>
        </div>
      </ng-container>

      <!-- Loader -->
      <ng-template #loading>
        <div class="flex py-4 items-center justify-center">
          <mat-spinner
            [diameter]="30"
            [strokeWidth]="3"
            [color]="'gray'"
          ></mat-spinner>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <!-- FOOTER <- PAGINATION -->
  <div class="flex py-2 px-3 border-t" *ngIf="pagination?.totalItems">
    <cvt-pagination
      (pageChanged)="itemsSelector.currentPage.next($event)"
      [pagination]="pagination"
    ></cvt-pagination>
  </div>
</div>
